import React from 'react';

var SnapshotError = React.createClass ({
  handleCloseClick: function(){
    this.props.snapshotError("close")
  },
  handleOutsideClick: function(e){
    e.stopPropagation();
  },
  render: function(){
    return (
        <div className="modal__mask" onClick = {this.handleCloseClick}>
          <div className="modal__content modal--md" onClick = {this.handleOutsideClick}>
            <div className="modal__header">
              <h3 className="modal__header--title">Warning: Package is out-of-sync</h3>
              <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}><i className="fa  fa-close"> </i></a> </div>
            <div className="modal__body clearfix">
              <div className="form__row clearfix">
                <p>Your local copy of Package <strong>"{this.props.slug}"</strong> is out-of-sync with the Hub. Before creating a snapshot, you need to pull or push in order to sync up with the Hub.</p>
              </div>
              <div className="buttons clearfix">      
                <button className="btn__lg bg-bright" onClick = {this.handleCloseClick}>Ok</button>
              </div>
            </div>
          </div>
        </div>
    )
  }
});

export {SnapshotError};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SnapshotError.jsx
 **/